import { HubConnectionBuilder } from '@microsoft/signalr';

import { ACCESS_TOKEN_KEY } from 'src/auth/context/jwt';

const url = `${process.env.REACT_APP_SERVER_URL}/hubs/app`;

export const connection = new HubConnectionBuilder()
  .withUrl(url, { accessTokenFactory: () => sessionStorage.getItem(ACCESS_TOKEN_KEY) })
  .withAutomaticReconnect()
  .build();
